import React from 'react';
import PropTypes from 'prop-types';

class ErrorControl extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    errorComponent: PropTypes.node.isRequired,
    error: PropTypes.bool.isRequired,
  };

  render() {
    const { error, errorComponent, children } = this.props;

    if (error) {
      return errorComponent;
    }

    return children;
  }
}

export { ErrorControl };
